export const CHAT_AREA_ID = 'chatMsgArea'
export const CHAT_INPUT_ID = 'chatMessageInput'

export const ChatInputElement = document.getElementById(CHAT_INPUT_ID)
export const ChatAreaElement = document.getElementById(CHAT_AREA_ID)
